var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQdWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50.6 188",
    style: {
      enableBackground: "new 0 0 50.6 188"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#247D91;}\n\t.st2{fill:#003E4C;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000016792960537037345330000005639569681634217088_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_03.Dotted-lines"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.1,
    y: 0.3,
    className: "st0",
    width: 8.6,
    height: 131.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.7,132h-8.5v-12h8.5V132z M28.7,108h-8.5V96h8.5V108z M28.7,84h-8.5V72h8.5V84z M28.7,59.9h-8.5v-12h8.5 V59.9z M28.7,35.9h-8.5v-12h8.5V35.9z M28.7,11.9h-8.5v-12h8.5V11.9z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M23,174.2c-0.5-0.2-1-0.6-1.5-1c-0.5-0.5-1.1-1-1.6-1.6s-1-1.2-1.4-1.7c-0.1,0-0.2,0-0.2,0s-0.2,0-0.3,0 c-1.6,0-3-0.3-3.9-0.9c-1-0.6-1.7-1.5-2.1-2.6c-0.4-1.2-0.6-2.5-0.6-4.1v-8.7c0-1.6,0.2-2.9,0.6-4c0.4-1.1,1.1-2,2.1-2.6 s2.3-0.9,3.9-0.9c1.7,0,3,0.3,4,0.9c1,0.6,1.7,1.5,2.1,2.6s0.6,2.5,0.6,4v8.7c0,1.1-0.1,2.1-0.3,3c-0.2,0.9-0.6,1.7-1,2.3 c-0.5,0.7-1.1,1.2-1.9,1.5c0.2,0.3,0.5,0.5,0.8,0.8s0.5,0.6,0.8,0.8s0.5,0.5,0.8,0.6L23,174.2z M17.9,166.7c0.7,0,1.2-0.2,1.6-0.5 c0.3-0.3,0.6-0.7,0.7-1.3c0.1-0.5,0.2-1.1,0.2-1.8v-10.7c0-0.7-0.1-1.2-0.2-1.8c-0.1-0.5-0.3-0.9-0.7-1.2 c-0.3-0.3-0.9-0.4-1.6-0.4s-1.2,0.1-1.6,0.4c-0.3,0.3-0.6,0.7-0.7,1.2c-0.1,0.5-0.2,1.1-0.2,1.8v10.7c0,0.6,0.1,1.2,0.2,1.8 c0.1,0.5,0.3,1,0.7,1.3C16.7,166.6,17.3,166.7,17.9,166.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M30.1,176.5c-1,0-1.8-0.4-2.3-1.1c-0.5-0.7-0.8-1.9-0.8-3.5V168c0-0.9,0.1-1.7,0.3-2.4c0.2-0.7,0.5-1.3,1-1.7 c0.4-0.4,1-0.6,1.8-0.6c0.5,0,0.9,0.1,1.3,0.3s0.7,0.4,1.1,0.7v-5.9h3v17.8h-3v-0.9c-0.3,0.3-0.7,0.6-1.1,0.8 C30.9,176.4,30.5,176.5,30.1,176.5z M31.2,174.5c0.2,0,0.3,0,0.6-0.1c0.2-0.1,0.4-0.2,0.6-0.3v-8.2c-0.2-0.1-0.4-0.2-0.6-0.3 s-0.4-0.1-0.6-0.1c-0.4,0-0.7,0.2-0.9,0.6c-0.2,0.4-0.3,0.9-0.3,1.4v4.8c0,0.4,0,0.8,0.1,1.1s0.2,0.6,0.3,0.8 C30.6,174.4,30.9,174.5,31.2,174.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQdWhite);
export default __webpack_public_path__ + "static/media/QdWhite.e1b818f428c512419ad840b8c0b0a5bd.svg";
export { ForwardRef as ReactComponent };